// extracted by mini-css-extract-plugin
export default {"menuBlock":"cE-z","title":"dE-z","nav":"eE-z","flexCell":"fE-z","facetLink":"gE-z"};